module.exports = __webpack_public_path__ + "static/pinkbunny1-bea49b0003f7abd817e5c64da11e451c.png";